<template>
	<div class="all-wizard">
		<div class="container-wizards">
			<h2 class="title-wizards" v-if="!estimator">Yes, your project requires Title 24 Compliance</h2>
			<h2 class="title-wizards" v-if="estimator">Select the correct cost estimator</h2>

			<b-modal id="modal1" ref="myModalRef" centered hide-footer size="lg" :title='titlePopUp'>
				<!-- Component PopUp -->
					<div class="bg notes" v-if="wichPopup === 'notes'">
						<h3>Notes</h3>
					</div>

					<div class="bg terms-bg-popUp" v-if="wichPopup === 'important'">
						<h3>Important Terms</h3>
					</div>

					<div class="bg terms-bg-popUp" v-if="wichPopup === 'covered'">
						<h3>Covered Processes</h3>
					</div>

					<div class="bg terms-bg-popUp" v-if="wichPopup === 'exempt'">
						<h3>Exempt Processes</h3>
					</div>

				<div class="content-pop">

						<notes v-if="wichPopup === 'notes'" />
						<importantTermns v-if="wichPopup === 'important'" />
						<coveredProcess v-if="wichPopup === 'covered'" />
						<exemptProcess v-if="wichPopup === 'exempt'" />
						<results v-if="wichPopup === 'results'" />
				</div>

				<div style="width: 100%; display: flex; justify-content:center;">
					<b-button class="mt-3" variant="outline-success" style="width: 20%;" block @click="hideModal">Close</b-button>
				</div>
			</b-modal>

			<div class= "black-note">
				*Unless your project's scope is
				<a @click="showModal('exempt', '')">
					<div class= "span-blue"> exempt.
					</div>
				</a>
			</div>

			<div class="sub-type">
				<div class="label">
					Select type of work to be performed:
				</div>

				<b-form-group label="" >
					<b-form-radio-group id="radios2" v-model="selectedSecondRadiosGroup" name="radioSubComponentType">
						<b-form-radio value="newBuilding"><span>New Building</span></b-form-radio>
						<b-form-radio value="existingPlusAdditions"><span>Existing-Plus-Addition/Alteration</span></b-form-radio>

					</b-form-radio-group>
				</b-form-group>

			</div>

			<!--
			<div class="buttons" v-if="selectedSecondRadiosGroup">
						<div class="btn" variant="link">
								<span class="info "  @click="showModal('notes', '')"><img class="icon-btn" v-b-tooltip.hover title="click to know Notes"  src="~Img/notes.png" ></span>
						</div>

						<div  class="btn" variant="link">
							<span class="info "  @click="showModal('important', '')"><img class="icon-btn" v-b-tooltip.hover title="click to know Important Terms"  src="~Img/importantTerms.png" ></span>
						</div>
			</div>
			<div class="btn" variant="link">
					<div class="info-text" @click="showModal('covered', '')"> List of Covered Processes </div>
			</div>
			<br>
			-->
			<div class="btn" variant="link">
				<div class="info-text" @click="showModal('notes', '')"> Notes </div>
			</div>
			<br>
			<div  class="btn" variant="link">
				<div class="info-text" @click="showModal('important', '')"> Important Terms </div>
			</div>
			<div class="components">
				<transition name="fade" mode="out-in">
					<newBuildingComponent option="AllOthers" v-if='whereAreWeSecond("newBuilding")' />
					<existingPlusAdditionsComponent v-if='whereAreWeSecond("existingPlusAdditions")' />
				</transition>
			</div>

		</div>

	</div>
</template>

<script>
import eventBus from '@/commonSite/eventBus.js'
import newBuildingComponent from './newBuilding.vue'
import existingPlusAdditionsComponent from './additionAlteration.vue'
import notes from '@/components/complianceWizard/pop/notes.vue'
import importantTermns from '@/components/complianceWizard/pop/importantTerms.vue'
import coveredProcess from '@/components/complianceWizard/pop/coveredProcess.vue'
import exemptProcess from '@/components/complianceWizard/pop/exempt.vue'
import LocalStorageService from '@/commonSite/StorageService.js'
export default {
	name: 'commercial-wizards',
	props: ['estimator'],
	components: {
		newBuildingComponent,
		existingPlusAdditionsComponent,
		notes,
		coveredProcess,
		exemptProcess,
		importantTermns
		// uploadPopUp
	},
	data: function () {
		return {
			selectedSecondRadiosGroup: null,
			activeTypeA: 1,
			wichPopup: '',
			isStopClass: true,
			fullServicecss: false,
			titlePopUp: '',
			showBtnFullService: null
		}
	},
	created () {
		this.getAccordionsValue()
		eventBus.$on('value-accordion-b', () => {
			// console.debug('father has speaked: and say b is closed ')
			this.selectedSecondRadiosGroup = ''
		})
	},
	methods: {
		setSecondState: function (tipo, cssWho) {
			this.selectedSecondRadiosGroup = tipo
			this.activeTypeA = cssWho
		},
		whereAreWeSecond: function (value) {
			// This method detect if select correct option return true
			if (this.selectedSecondRadiosGroup === value) {
				return true
			}
			this.setAccordionState()
		},
		showModal (value, title) {
			this.titlePopUp = title
			this.isStopClass = false
			this.fullServicecss = true
			this.wichPopup = value
			this.$refs.myModalRef.show()
		},
		hideModal () {
			this.$refs.myModalRef.hide()
		},
		getAccordionsValue () {
			let localStorage = new LocalStorageService()
			this.selectedSecondRadiosGroup = localStorage.findItem('subMenuCommercial', true)
		},
		setAccordionState () {
			let localStorage = new LocalStorageService()
			localStorage.setItem('subMenuCommercial', this.selectedSecondRadiosGroup, true)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/complianceWizard/commercialWizards/MenuComercial.vue